
if($('.single-slider .slide-list .slide_box').length > 1){  
  $('.single-slider .slide-list').slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    adaptiveHeight: true
  });
} 
  $('.loved-pieces .loved-pieces-sub').slick({
  dots: true,
  infinite: false,
     mobileFirst:true,
  speed: 300,
  slidesToShow: 5,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1199,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 320,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});

$('.new-arrivals .new-arrivals-sub').slick({
  dots: true,
  infinite: false,
     mobileFirst:true,
  speed: 300,
  slidesToShow: 5,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1199,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 320,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});



// $('.new-arrivals .new-arrivals-sub').slick({
//   dots: false,
//   infinite: false,
//   speed: 300,
//   slidesToShow: 5,
//   slidesToScroll: 4,
//   responsive: [
//     {
//       breakpoint: 1024,
//       settings: {
//         slidesToShow: 3,
//         slidesToScroll: 3,
//         infinite: true,
//         dots: false
//       }
//     },
//     {
//       breakpoint: 767,
//       settings: {
//         slidesToShow: 2,
//         slidesToScroll: 2
//       }
//     },
//     {
//       breakpoint: 480,
//       settings: {
//         slidesToShow: 1,
//         slidesToScroll: 1
//       }
//     }
     
//   ]
// });

$('.reviews-bg .customer-list').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2000,
  responsive: [
    {
      breakpoint: 1199,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 3,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});



   $('.slider-for').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  dots: false,
  fade: true,
  asNavFor: '.slider-nav'
});

  $('.slider-nav').slick({
      slidesToShow: 3,
      infinite: false,
      slidesToScroll: 1,
      asNavFor: '.slider-for',
      dots: false,
      focusOnSelect: true,
      vertical: true,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            vertical: false,
            slidesToShow: 4,
          }
        }
      ]
  }); 

	



// mobile menus toggle
$(document).on('click','.mobile-nav-trigger',function(e){
  document.querySelector("body").classList.remove('search-open');

  if ($('body').hasClass('menu-open')){
    $('body').removeClass('menu-open');
  } else {
    $('body').addClass('menu-open'); 
  }
});

$(document).on('click','.overlay-block',function(e){
// $('.overlay-block').on('click', function() {
  $('body').removeClass('menu-open');		  	
});

$(document).on('click','.mobile_svg',function(e){
  e.preventDefault();

  const $currentSubmenu = $(this).parent().find('.mega-menu-content');

  if ($currentSubmenu.hasClass('submenu_open')) {
      $currentSubmenu.removeClass('submenu_open');
  } else {
      $('.mega-menu-content').removeClass('submenu_open');
      $currentSubmenu.addClass('submenu_open');
  }
});
// mobile menus toggle ends


document.querySelector(".search-trigger").addEventListener("click",()=>{
  document.querySelector("body").classList.remove('menu-open');
  document.body.classList.toggle("search-open");
});


// document.querySelector(".close-icon").addEventListener("click",()=>{
//   document.body.classList.remove("search-open");
// });


// collection page on variant change update image and price
document.addEventListener("click", function (e) {
  const variantBtn = e.target.closest(".product_grid_variants");
  if (!variantBtn) return;

  const variantImage = variantBtn.dataset.variantImage;
  const variantPrice = variantBtn.dataset.variantPrice;

  // Find parent product item
  const productItem = variantBtn.closest(".product_grid_item");
  if (!productItem) return;

  const allVariants = productItem.querySelectorAll(".product_grid_variants");
  allVariants.forEach(v => v.classList.remove("active"));
  variantBtn.classList.add('active');

  // Update image
  const imgEl = productItem.querySelector(".product_grid_img");
  if (imgEl && variantImage) {
    imgEl.src = variantImage;
  }

  // Update price text
  const priceEl = productItem.querySelector(".product_grid_price");
  if (priceEl && variantPrice) {
    priceEl.textContent = variantPrice;
  }
});

// tabbed content
// http://www.entheosweb.com/tutorials/css/tabs.asp
$(".tab-container .tab_content").hide();
// $(".tab-container .tab_content:first").show();
$('.tab-container').each(function(k,v){
  $(v).find('.tab_content:first').show();
});

/* if in tab mode */
$("ul.tabs li").click(function() {
  var parent = $(this).parents('.tab-container');

  $(parent).find(".tab_content").hide();
  var activeTab = $(this).attr("rel");
  $(parent).find("#"+activeTab).fadeIn();

  $(parent).find("ul.tabs li").removeClass("active");
  $(this).addClass("active");

  $(parent).find(".tab_drawer_heading").removeClass("d_active");
  $(parent).find(".tab_drawer_heading[rel^='"+activeTab+"']").addClass("d_active");

});
/* if in drawer mode */
$(".tab_drawer_heading").click(function() {
  var parent = $(this).parents('.tab-container');

  $(parent).find(".tab_content").hide();
  var d_activeTab = $(this).attr("rel");
  $(parent).find("#"+d_activeTab).fadeIn();

  $(parent).find(".tab_drawer_heading").removeClass("d_active");
  $(this).addClass("d_active");

  $(parent).find("ul.tabs li").removeClass("active");
  $(parent).find("ul.tabs li[rel^='"+d_activeTab+"']").addClass("active");
});




// popup
$(document).ready(function() {

  $('.sm_open').on('click', function(){
      var modal = $(this).attr('data-modal');
      var modaloverlaycolor = $(this).attr('data-overlay');
      var modaleffect = $(this).attr('data-effect');
      var modalheader = $(this).attr('data-header');
      var modalheadertype = $(this).attr('data-header-type');
      var modalcontent = $(this).attr('data-content');
      var modaliconside = $(this).attr('data-icons');
      var modalwrappercolor = $(this).attr('data-wrapper-color');

      $('#' + modal).addClass(modaloverlaycolor);
      $('#' + modal + ' .sm_content').addClass(modaleffect);
      $('#' + modal + ' .sm_content .sm_header').html(modalheader);
      $('#' + modal + ' .sm_content .sm_header').addClass(modalheadertype);
      $('#' + modal + ' .sm_content .sm_area_all').html(modalcontent);
      $('#' + modal + ' .sm_icon_menu').addClass(modaliconside);
      $('#' + modal + ' .sm_content').addClass(modalwrappercolor);
      $('#' + modal).fadeIn().css("display", "flex");
      setTimeout(function(){
          $('#'+modal + ' .sm_content').addClass('show');
      }, 400);        
  });

  $('.sm_close').on('click', function(){
      var $modal = $(this).parents('.slim_modal');
      closeModal($modal);  
  });

  $('.slim_modal').on('click', function(e) {
  if (e.target !== this)
    return;
  var $modal = $(this);
    closeModal($modal);
});
  
  function closeModal($modal) {
    $modal.find('.sm_content').removeClass('show');
      setTimeout(function(){
        $modal.removeClass('red green tan none');
        $modal.find('.sm_content').removeClass('red green tan');
        $modal.find('.sm_icon_menu').removeClass('is_right is_left');
        $modal.find('.sm_header').removeClass('detached');
          $modal.fadeOut();
      }, 400);
  }
});

$("#accordion > li > h3").click(function(){

		if(false == $(this).next().is(':visible')) {
			$('#accordion ul').slideUp(300);
		}
	
		var classnm = $(this).parent('li').attr("class");
		// Line Added to remove the active class from all 'li'
		$('#accordion > li').removeClass('active');
		// Line Added to remove the blank attribute of class from all 'li'
		$('#accordion > li[class=""]').removeAttr('class');
		// Line Added to add the active class in current 'li'
	
		$(this).next().slideToggle(300);
	
		if(classnm == "undefined" || classnm == "" || classnm == undefined){
			$(this).parent('li').addClass('active');
		}
	});

	$('#accordion ul:eq(0)').hide();
	$("#accordion li").eq(0).addClass("active");
	$("#accordion li").eq(0).find("ul").show();